import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js'

type CountryEntry = {
  flag: string
  country: CountryCode
  title: string
  countryCallingCode: string
}

export type CountryCodeEntry = {
  id: CountryCode
  name: string
  phone_prefix: string
}

const countryArr: CountryEntry[] = []
const countryCallingCodeToCountryCodeMap: { [code: string]: CountryCode } = {}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore this is correct typings, but we need to fulfill this map later
const countryCodeToCallingCodeMap: { [code in CountryCode]: string } = {}

const countries = getCountries()

countries.forEach(country => {
  const callingCode = getCountryCallingCode(country) as string
  countryCodeToCallingCodeMap[country] = getCountryCallingCode(country) as string
  countryCallingCodeToCountryCodeMap[callingCode] = country
})

export const matchCountryCode = (phoneCode: string): CountryCode | undefined => {
  return countryCallingCodeToCountryCodeMap[phoneCode]
}

export const matchCallingCode = (countryCode: CountryCode): string | undefined => {
  return countryCodeToCallingCodeMap[countryCode]
}

export const getCountryByCountryCode = (countryCode: CountryCode): CountryEntry | undefined => {
  return countryArr.find(item => item.country === countryCode)
}

export const countryList: CountryEntry[] = countryArr
